module.exports = __webpack_public_path__ + "c8132fd7ea5cb8c0e56e1a46a04a8684.fbx";